import { createAction } from '@reduxjs/toolkit';

import { ILoadPublicAlbumListSuccess, ILoadPublicAlbumPageSuccess } from './publicAlbum.types';

export const loadPublicAlbumPageSuccess = createAction<ILoadPublicAlbumPageSuccess>('publicAlbums/loadAlbumPageSuccess');
export const loadPublicAlbumListSuccess = createAction<ILoadPublicAlbumListSuccess>('publicAlbums/loadPublicAlbumListSuccess');
